import styles from "@css/modules/pointsGuide.module.scss"
import { useState } from "react"
import cn from "classnames"
import { Select } from "antd"
import { ArrowDown, Close } from "@css/icons/SVG"
import { getPointChartData } from "@lib/api/resorts"
import { RadioButtons } from "@components/RadioButtons"
import { yesNoItems } from "./utils/utils"

export function Step4({ onChange, goNext, goBack, lastValue, resorts }) {
    const [value, setValue] = useState(() => lastValue?.resort)
    const [checked, setChecked] = useState(lastValue?.checked)
    const [disabled, setDisabled] = useState(false)
    const onGoNext = async () => {
        if (!disabled) {
            setDisabled(true)
            let charts
            let hiddenResort = value
            try {
                hiddenResort = value || resorts.find((i) => i.slug === "old-key-west")
                charts = await getPointChartData(hiddenResort.id)
            } finally {
                setDisabled(false)
            }
            const currentYear = new Date().getFullYear()
            const c = charts.filter((i) => i.year >= currentYear)
            onChange({
                resort: value,
                hiddenResort,
                checked,
                currentChart: c.find((i) => i.year === currentYear) || c[0] || charts[0],
                charts: c.length ? c : charts
            })
            goNext()
        }
    }
    const changeYesNo = (event) => {
        setChecked(event.target.value)
    }
    const changeResort = (name) => {
        const newResort = resorts.find((i) => i.short_name === name)
        setValue(newResort)
    }
    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepContent} id="scroll-target">
                <h2>Have you already decided on a home resort yet?</h2>
                <div className={styles.step4Content}>
                    <RadioButtons items={yesNoItems} name="yesNo" onChange={changeYesNo} defaultValue={checked} />
                    {checked === "yes" && (
                        <Select
                            allowClear
                            clearIcon={<Close />}
                            onChange={changeResort}
                            className={cn(styles.selectField)}
                            name="resort"
                            id="resort"
                            value={value?.short_name || null}
                            placeholder="Choose your Resort"
                            suffixIcon={<ArrowDown />}>
                            {resorts.map((i) => {
                                return (
                                    <Select.Option key={i.short_name} value={i.short_name}>
                                        {i.short_name}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    )}
                </div>
                <div className={styles.overBackNext}>
                    <button className={styles.goBack} onClick={goBack}>
                        Back
                    </button>
                    <button disabled={disabled || (checked === "yes" && !value)} className={styles.goNext} onClick={onGoNext}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )
}
